export default {
  login: "bc160201983",
  id: 41289168,
  node_id: "MDQ6VXNlcjQxMjg5MTY4",
  avatar_url: "https://avatars.githubusercontent.com/u/41289168?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/bc160201983",
  html_url: "https://github.com/bc160201983",
  followers_url: "https://api.github.com/users/bc160201983/followers",
  following_url:
    "https://api.github.com/users/bc160201983/following{/other_user}",
  gists_url: "https://api.github.com/users/bc160201983/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/bc160201983/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/bc160201983/subscriptions",
  organizations_url: "https://api.github.com/users/bc160201983/orgs",
  repos_url: "https://api.github.com/users/bc160201983/repos",
  events_url: "https://api.github.com/users/bc160201983/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/bc160201983/received_events",
  type: "User",
  site_admin: false,
  name: "Muhammad Bilal",
  company: null,
  blog: "https://bilalafzaal.vercel.app/",
  location: "Pakistan",
  email: null,
  hireable: null,
  bio: "JavaScript Web Engineer | ReactJS | NextJS | NodeJS",
  twitter_username: null,
  public_repos: 19,
  public_gists: 0,
  followers: 0,
  following: 0,
  created_at: "2018-07-16T10:13:48Z",
  updated_at: "2022-04-01T14:03:58Z",
};
